import { FC, ReactElement } from 'react';

import { Skeleton, Wrapper } from '../../../../../components';
import { generateIdArray } from '../../../../../helpers/array';
import { randomInBetweenValue } from '../../../../../helpers/number';

import './SpaceDetailRendererSkeletons.scss';

interface SpaceDetailRendererSkeletonsProps {
    className?: string;
}

export const SpaceDetailRendererSkeletons: FC<SpaceDetailRendererSkeletonsProps> = ({
    className = '',
}): ReactElement => {
    const numberOfCarouselItems = randomInBetweenValue(3, 5);
    const carouselItemSkeletons = generateIdArray(numberOfCarouselItems);

    return (
        <div className={`space-detail-renderer-skeletons ${className}`}>
            <Wrapper>
                <div className="space-detail-renderer-skeletons__breadcrumbs-wrapper">
                    <Skeleton className="space-detail-renderer-skeletons__breadcrumbs" />
                </div>
            </Wrapper>

            <div className="space-detail-renderer-skeletons__carousel-wrapper">
                <Wrapper>
                    <div className="space-detail-renderer-skeletons__carousel-title-wrapper">
                        <Skeleton className="space-detail-renderer-skeletons__carousel-title" />
                    </div>
                </Wrapper>

                <div className="space-detail-renderer-skeletons__carousel">
                    {carouselItemSkeletons.map(skeleton => (
                        <Skeleton
                            key={skeleton}
                            className="space-detail-renderer-skeletons__carousel-item"
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};
